function areAllValuesTheSame(responsiveValue) {
  if ('narrow' in responsiveValue && 'regular' in responsiveValue && 'wide' in responsiveValue) {
    const values = Object.values(responsiveValue);
    return values.every(value => value === values[0]);
  }
  return false;
}
function haveRegularAndWideSameValue(responsiveValue) {
  if ('regular' in responsiveValue && 'wide' in responsiveValue) {
    return responsiveValue.regular === responsiveValue.wide;
  }
  return false;
}

export { areAllValuesTheSame, haveRegularAndWideSameValue };
